import React from "react";

const DepositModal = ({ toggleModal }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={toggleModal}
      ></div>

      <div className="relative w-full max-w-md p-6 mx-4 bg-white rounded-lg shadow-xl">
        <button
          onClick={toggleModal}
          className="absolute text-gray-500 hover:text-gray-700 top-4 right-4"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>

        <div className="mb-4">
          <h3 className="text-xl font-bold text-themeBlack">
            Hasar Depozito Bilgileri
          </h3>
        </div>
        <div className="space-y-4">
          <p className="text-sm text-gray-600">
            Hasar depozitosu villaya girişte ekstra olarak alınır ve villadan
            çıkış yaparken bir hasar olmaması durumunda geri iade edilir.
          </p>
        </div>
        <div className="flex justify-end mt-6">
          <button
            onClick={toggleModal}
            className="px-4 py-2 text-sm font-medium text-white bg-themeBlack rounded-lg hover:bg-gray-800"
          >
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default DepositModal;
